export default "__VITE_ASSET__aadc9c73__"